module.exports = __webpack_public_path__ + "officialStatic/img/made3.44e4efd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/made3.jpg
// module id = O5/V
// module chunks = 0